import { RemoteGeneratePartnerRequestKey } from 'data/usecases/partners';
import { makeApiUrlPartners } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGeneratePartnerRequestKey = (): RemoteGeneratePartnerRequestKey => {
  return new RemoteGeneratePartnerRequestKey(
    makeApiUrlPartners(),
    makeAxiosHttpClient(),
  );
};
